module.exports = __webpack_public_path__ + "img/4-2.18fc326d.svg";